import React from 'react';
import { Badge } from '../ui/badge';

const tagColors = {
  'organic': 'bg-success/10 text-success border-success/20',
  'vegan': 'bg-success/10 text-success border-success/20',
  'cruelty-free': 'bg-primary/10 text-primary border-primary/20',
  'natural': 'bg-primary/10 text-primary border-primary/20',
  'hypoallergenic': 'bg-accent/20 text-accent-foreground border-accent/30',
  'dermatologist-tested': 'bg-accent/20 text-accent-foreground border-accent/30',
  'paraben-free': 'bg-muted text-muted-foreground border-border',
  'sulfate-free': 'bg-muted text-muted-foreground border-border'
};

export const ProductTags = ({ product, className = '' }) => {
  // Generate tags based on product properties
  const tags = [];
  
  if (product.ingredients?.toLowerCase().includes('organic')) tags.push('organic');
  if (product.warnings?.toLowerCase().includes('cruelty')) tags.push('cruelty-free');
  if (product.description?.toLowerCase().includes('natural')) tags.push('natural');
  if (product.description?.toLowerCase().includes('hypoallergenic')) tags.push('hypoallergenic');
  if (product.warnings?.toLowerCase().includes('dermatologist')) tags.push('dermatologist-tested');
  if (product.ingredients?.toLowerCase().includes('paraben-free')) tags.push('paraben-free');
  if (product.name?.toLowerCase().includes('sulfate-free')) tags.push('sulfate-free');
  
  // Default tags for baby products
  if (product.name?.toLowerCase().includes('baby')) {
    tags.push('hypoallergenic', 'dermatologist-tested');
  }
  
  // Remove duplicates
  const uniqueTags = [...new Set(tags)];
  
  if (uniqueTags.length === 0) return null;

  return (
    <div className={`flex flex-wrap gap-2 ${className}`}>
      {uniqueTags.slice(0, 3).map(tag => (
        <Badge
          key={tag}
          variant="outline"
          className={`text-xs ${tagColors[tag] || 'bg-muted text-muted-foreground'}`}
        >
          {tag.split('-').map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}
        </Badge>
      ))}
    </div>
  );
};